import { Injectable } from "@angular/core";
import { StateService } from '@uirouter/angular';
import { GfTranslateService } from "../../../core/services/core.translate.service";
import { GfTitleService } from "../../../core/services/core.title.service";
import * as _ from 'lodash';

@Injectable()
export class FrsReleaseDisplayService {
    constructor(
        private stateService: StateService,
        private gfTranslateService: GfTranslateService,
        private $window: Window,
        private titleService: GfTitleService,
    ) {}

    breadcrumbsFor(project, release?) {
        var ret: any[] = [
            {
                label: project.name,
                state: 'home.project.summary',
                params: this.stateService.params
            },
            {
                label: this.gfTranslateService.translate('Releases'),
                state: 'home.project.summary.frs',
                params: this.stateService.params
            }
        ];

        if (release) {
            ret.push({ label: release.releaseName });
        }
        return ret;
    }

    setWindowTitle(project, release) {
        var segments = [project.name, this.gfTranslateService.translate('Release Details')];

        if (release) {
            segments.push(release.releaseName);
        }

        var ret = segments.join(' - ');
        this.titleService.setTitle(ret);
        return ret;
    }

    getPercentComplete(rel) {
        var closed = _.get(rel, 'rel.tisummary.closed_tracker_items_count', 0);
        var total = _.get(rel, 'rel.tisummary.tracker_items_count', 0);
        if (closed == 0 || total == 0) return 0;
        return Math.round((closed / total) * 100);
    }

    openDownload(url) { return this.$window.open(url, '_blank'); }    
}